export default __webpack_public_path__ + "static/media/paywithcrypto1.666c3add.png";